/* tslint:disable */
/* eslint-disable */
/* Mocked in-memory implementation of PrimaryCategoryClient for local development and UI wiring. */

import { CancelToken } from 'axios';
import {
  SuccessResponse_1OfList_1OfPrimaryCategory,
  SuccessResponse_1OfList_1OfPrimaryCategoryStockCount,
  SuccessResponse_1OfPrimaryCategory,
  SuccessResponse_1OfBulkAddResponse,
  PrimaryCategory2,
  ItemPrimaryCategoryOverride,
} from '../../types';

/* ---- Helper Functions ---- */

function delay(ms: number = 300): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function successResponse<T>(data: T): { data: T; success: boolean; message: string } {
  return { data, success: true, message: 'Success' };
}

/* ---- Mock Data ---- */

const mockPrimaryCategories = [
  { id: 1, name: 'Dairy', storeNumber: 'STORE001', itemCount: 25, isActive: true },
  { id: 2, name: 'Bakery', storeNumber: 'STORE001', itemCount: 18, isActive: true },
  { id: 3, name: 'Beverages', storeNumber: 'STORE001', itemCount: 42, isActive: true },
  { id: 4, name: 'Frozen', storeNumber: 'STORE001', itemCount: 30, isActive: true },
];

const mockCategoryItems = [
  { itemNumber: 'ITEM001', description: 'Whole Milk', primaryCategoryId: 1, counted: true, inStock: true },
  { itemNumber: 'ITEM002', description: 'Skimmed Milk', primaryCategoryId: 1, counted: false, inStock: true },
];

/* ---- Mocked Client Implementation ---- */

import { IPrimaryCategoryClient } from '../../interfaces';
export class PrimaryCategoryClientMocked implements IPrimaryCategoryClient {
  constructor(baseUrl?: string) {}

  async get2(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfPrimaryCategory> {
    await delay();
    const categories = mockPrimaryCategories.filter((c) => c.storeNumber === storeNumber);
    return successResponse(categories) as SuccessResponse_1OfList_1OfPrimaryCategory;
  }

  async getWithCounts(storeNumber: string, cancelToken?: CancelToken): Promise<SuccessResponse_1OfList_1OfPrimaryCategoryStockCount> {
    await delay();
    const categories = mockPrimaryCategories
      .filter((c) => c.storeNumber === storeNumber)
      .map((c) => ({ ...c, countedItems: Math.floor(c.itemCount * 0.8), totalItems: c.itemCount }));
    return successResponse(categories) as SuccessResponse_1OfList_1OfPrimaryCategoryStockCount;
  }

  async getById(id: number, cancelToken?: CancelToken): Promise<SuccessResponse_1OfPrimaryCategory> {
    await delay();
    const category = mockPrimaryCategories.find((c) => c.id === id) || mockPrimaryCategories[0];
    return successResponse(category) as SuccessResponse_1OfPrimaryCategory;
  }

  async post(body?: PrimaryCategory2, cancelToken?: CancelToken): Promise<SuccessResponse_1OfPrimaryCategory> {
    await delay();
    const newCategory = {
      id: mockPrimaryCategories.length + 1,
      name: body?.primaryCategoryName || 'New Category',
      storeNumber: 'STORE001',
      itemCount: 0,
      isActive: true,
    };
    mockPrimaryCategories.push(newCategory);
    return successResponse(newCategory) as SuccessResponse_1OfPrimaryCategory;
  }

  async postAddBulk(id: number, body?: string[], cancelToken?: CancelToken): Promise<SuccessResponse_1OfBulkAddResponse> {
    await delay();
    return successResponse({
      success: body || [],
      fails: [],
    }) as SuccessResponse_1OfBulkAddResponse;
  }

  async primarycategoryPATCH(id: number, body?: PrimaryCategory2, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const category = mockPrimaryCategories.find((c) => c.id === id);
    if (category && body) {
      category.name = body.primaryCategoryName || category.name;
    }
  }

  async primarycategoryDELETE(id: number, cancelToken?: CancelToken): Promise<void> {
    await delay();
    const index = mockPrimaryCategories.findIndex((c) => c.id === id);
    if (index > -1) {
      mockPrimaryCategories.splice(index, 1);
    }
  }

  async items(
    primaryCategoryId: number,
    search?: string,
    skip?: number,
    take?: number,
    direction?: string,
    fieldToSort?: string,
    isCountedOrAdded?: boolean,
    isInStock?: boolean,
    cancelToken?: CancelToken
  ): Promise<{ data: typeof mockCategoryItems; totalCount: number }> {
    await delay();
    let items = mockCategoryItems.filter((i) => i.primaryCategoryId === primaryCategoryId);
    if (search) {
      items = items.filter(
        (i) =>
          i.itemNumber.toLowerCase().includes(search.toLowerCase()) ||
          i.description.toLowerCase().includes(search.toLowerCase())
      );
    }
    const start = skip || 0;
    const end = start + (take || 10);
    return {
      data: items.slice(start, end),
      totalCount: items.length,
    };
  }

  async itemsPOST(primaryCategoryId: number, body?: ItemPrimaryCategoryOverride, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async deleteItemFromCategory(primaryCategoryId: number, body?: ItemPrimaryCategoryOverride, cancelToken?: CancelToken): Promise<void> {
    await delay();
  }

  async search(
    storeNumber: string,
    search?: string,
    skip?: number,
    take?: number,
    direction?: string,
    cancelToken?: CancelToken
  ): Promise<{ data: typeof mockCategoryItems; totalCount: number }> {
    await delay();
    let items = mockCategoryItems;
    if (search) {
      items = items.filter(
        (i) =>
          i.itemNumber.toLowerCase().includes(search.toLowerCase()) ||
          i.description.toLowerCase().includes(search.toLowerCase())
      );
    }
    const start = skip || 0;
    const end = start + (take || 10);
    return {
      data: items.slice(start, end),
      totalCount: items.length,
    };
  }

  // ====== Auto-generated stub methods ======












    async applyPrimaryCategory(storeNumber: string, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method applyPrimaryCategory not implemented in mocked client');
    }

    async updateCategorySalesForecast(id: number, value: boolean, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method updateCategorySalesForecast not implemented in mocked client');
    }

    async updateCategoryWasteCheckSheet(id: number, value: boolean, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method updateCategoryWasteCheckSheet not implemented in mocked client');
    }

    async delete(storeNumber: string, id: number, substituteId: number, cancelToken?: CancelToken | undefined): Promise<void> {
        throw new Error('Method delete not implemented in mocked client');
    }

}
